import { render, staticRenderFns } from "./icon-arrow.vue?vue&type=template&id=62f3b9d0"
import script from "./icon-arrow.vue?vue&type=script&lang=ts"
export * from "./icon-arrow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports